<div class="mini-spinner-container" role="alert">
  <div class="loading-bar">
    <div class="bar1"></div>
    <div class="bar2"></div>
    <div class="bar3"></div>
    <div class="bar4"></div>
    <div class="bar5"></div>
  </div>
  <p class="sr-only">
    {{ UI_STRINGS.LOADING | translateString }}
  </p>
</div>
